function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { autoUpdate, FloatingFocusManager, FloatingOverlay, FloatingPortal, offset, useClick, useDismiss, useFloating, useInteractions, useRole } from '@floating-ui/react';
import T from 'prop-types';
import React, { createContext, forwardRef, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAsyncFn, useCopyToClipboard } from 'react-use';
import classNames from 'classnames';
import _ from 'lodash/fp';
import { Badge } from 'react-bootstrap';
import Button from '../../../../../components/button/Button';
import Icon from '../../../../../components/icon/Icon';
import useBreakpoint from '../../../../../hooks/useBreakpoint';
import { alertError } from '../../../../../redux/actions';
import text from '../../../../../text';
import { client } from '../../../../../utilities/api';
import { captureError } from '../../../../../utilities/error';
var ShareLinkContext = /*#__PURE__*/ createContext({});
var ShareLinkProvider = function(param) {
    var children = param.children, createBookmarkState = param.createBookmarkState, onOpen = param.onOpen, listRequests = param.listRequests, listRequestsState = param.listRequestsState, getRequestAccessCount = param.getRequestAccessCount, getRequestAccessCountState = param.getRequestAccessCountState, showHomeIcon = param.showHomeIcon, new3dBookmark = param.new3dBookmark, small = param.small;
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _useFloating = useFloating({
        open: isOpen,
        onOpenChange: function(value) {
            if (value) {
                onOpen();
            }
            setIsOpen(value);
        },
        placement: 'bottom-end',
        middleware: [
            offset(4)
        ],
        whileElementsMounted: autoUpdate
    }), refs = _useFloating.refs, floatingStyles = _useFloating.floatingStyles, context = _useFloating.context;
    var click = useClick(context);
    var dismiss = useDismiss(context);
    var role = useRole(context);
    var _useInteractions = useInteractions([
        click,
        dismiss,
        role
    ]), getReferenceProps = _useInteractions.getReferenceProps, getFloatingProps = _useInteractions.getFloatingProps;
    var isBottomCard = useBreakpoint([
        'xs',
        'sm',
        'md'
    ]);
    return /*#__PURE__*/ React.createElement(ShareLinkContext.Provider, {
        value: {
            refs: refs,
            isOpen: isOpen,
            setIsOpen: setIsOpen,
            floatingStyles: floatingStyles,
            context: context,
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            createBookmarkState: createBookmarkState,
            listRequests: listRequests,
            listRequestsState: listRequestsState,
            getRequestAccessCount: getRequestAccessCount,
            getRequestAccessCountState: getRequestAccessCountState,
            showHomeIcon: showHomeIcon,
            isBottomCard: isBottomCard,
            new3dBookmark: new3dBookmark,
            small: small
        }
    }, children);
};
ShareLinkProvider.propTypes = {
    children: T.node.isRequired,
    createBookmarkState: T.shape({
        loading: T.bool.isRequired
    }).isRequired,
    // called when the share link is clicked to **open** the content, not when it is closed
    onOpen: T.func.isRequired,
    listRequests: T.func.isRequired,
    listRequestsState: T.shape({
        loading: T.bool.isRequired,
        value: T.oneOfType([
            T.shape({
                data: T.array.isRequired
            }),
            T.object
        ])
    }),
    getRequestAccessCount: T.func.isRequired,
    getRequestAccessCountState: T.shape({
        loading: T.bool.isRequired,
        value: T.oneOfType([
            T.number,
            T.object
        ])
    }),
    showHomeIcon: T.bool,
    new3dBookmark: T.func,
    small: T.bool
};
var updateRequestAccess = function(status, request) {
    return /*#__PURE__*/ _async_to_generator(function() {
        var resp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.updateRequestAccess(request.project.id, request.user.id, status)
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        2,
                        resp.data
                    ];
            }
        });
    });
};
var AccessRequestListItem = function(param) {
    var key = param.key, request = param.request;
    var _request_project_jobs;
    var _useContext = useContext(ShareLinkContext), listRequests = _useContext.listRequests, getRequestAccessCount = _useContext.getRequestAccessCount;
    var _useAsyncFn = _sliced_to_array(useAsyncFn(updateRequestAccess('rejected', request), [
        request
    ]), 2), rejectState = _useAsyncFn[0], reject = _useAsyncFn[1];
    var _useAsyncFn1 = _sliced_to_array(useAsyncFn(updateRequestAccess('accepted', request), [
        request
    ]), 2), approveState = _useAsyncFn1[0], approve = _useAsyncFn1[1];
    var _useState = _sliced_to_array(useState(false), 2), loading = _useState[0], setLoading = _useState[1];
    var handleUpdate = function(updateFn) {
        return /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            ,
                            3,
                            4
                        ]);
                        setLoading(true);
                        return [
                            4,
                            updateFn()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            Promise.all([
                                listRequests(),
                                getRequestAccessCount()
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return /*#__PURE__*/ React.createElement("li", {
        key: key
    }, /*#__PURE__*/ React.createElement("h6", null, "Access Request"), /*#__PURE__*/ React.createElement("p", null, text('hasRequestedAccess', {
        fullName: request.user.full_name,
        email: request.user.email
    }), /*#__PURE__*/ React.createElement("br", null), "".concat(text('projectName'), ": ").concat(request.project.name), /*#__PURE__*/ React.createElement("br", null), "".concat(text('projectAddress'), ": ").concat((_request_project_jobs = request.project.jobs) === null || _request_project_jobs === void 0 ? void 0 : _request_project_jobs[0].full_address)), /*#__PURE__*/ React.createElement("div", {
        className: "share-link__request-actions"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "danger",
        loading: rejectState.loading,
        onClick: loading ? _.noop : handleUpdate(reject),
        icon: "deny"
    }, text('deny')), /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        loading: approveState.loading,
        onClick: loading ? _.noop : handleUpdate(approve),
        icon: "approve"
    }, text('grant'))));
};
AccessRequestListItem.propTypes = {
    key: T.string.isRequired,
    request: T.object.isRequired
};
var ConditionalWrap = function(param) {
    var condition = param.condition, wrap = param.wrap, children = param.children;
    return condition ? wrap(children) : children;
};
var ShareLinkContent = /*#__PURE__*/ forwardRef(function(__, ref) {
    var _listRequestsState_value;
    var _useContext = useContext(ShareLinkContext), floatingStyles = _useContext.floatingStyles, getFloatingProps = _useContext.getFloatingProps, createBookmarkState = _useContext.createBookmarkState, listRequestsState = _useContext.listRequestsState, showHomeIcon = _useContext.showHomeIcon, isBottomCard = _useContext.isBottomCard, new3dBookmark = _useContext.new3dBookmark;
    var data = (_listRequestsState_value = listRequestsState.value) === null || _listRequestsState_value === void 0 ? void 0 : _listRequestsState_value.data;
    return /*#__PURE__*/ React.createElement(FloatingPortal, null, /*#__PURE__*/ React.createElement(ConditionalWrap, {
        condition: isBottomCard,
        wrap: function(children) {
            return /*#__PURE__*/ React.createElement(FloatingOverlay, {
                className: classNames('share-link__overlay', isBottomCard && 'enabled')
            }, children);
        }
    }, /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        ref: ref
    }, !isBottomCard && {
        style: _object_spread_props(_object_spread({}, floatingStyles), {
            zIndex: 1001
        })
    }, getFloatingProps()), {
        className: "share-link__content"
    }), /*#__PURE__*/ React.createElement("section", {
        className: "share-link__copy-confirmation"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "group"
    }, showHomeIcon ? /*#__PURE__*/ React.createElement(Icon, {
        icon: "home"
    }) : null, /*#__PURE__*/ React.createElement("span", null, createBookmarkState.loading ? text('copyingLinkToPage') : createBookmarkState.value && !createBookmarkState.error ? text('linkToPageCopied') : null))), new3dBookmark ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "share-link__divider"
    }), /*#__PURE__*/ React.createElement("section", {
        className: "share-link__new-3d-bookmark"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "group"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "bookmark"
    }), /*#__PURE__*/ React.createElement("span", null, text('new3dBookmark'))), /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        onClick: new3dBookmark
    }, text('openBookmarks')))) : null, !listRequestsState.error && (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "share-link__divider"
    }), /*#__PURE__*/ React.createElement("section", {
        className: "share-link__requests"
    }, /*#__PURE__*/ React.createElement("ul", null, data === null || data === void 0 ? void 0 : data.map(function(request, i) {
        return /*#__PURE__*/ React.createElement(AccessRequestListItem, {
            key: "AccessRequest".concat(i),
            request: request
        });
    })))) : null)));
});
ShareLinkContent.displayName = 'ShareLinkContent';
var ShareLinkButton = /*#__PURE__*/ forwardRef(function(__, ref) {
    var _useContext = useContext(ShareLinkContext), getReferenceProps = _useContext.getReferenceProps, getRequestAccessCount = _useContext.getRequestAccessCount, getRequestAccessCountState = _useContext.getRequestAccessCountState, small = _useContext.small;
    var count = getRequestAccessCountState === null || getRequestAccessCountState === void 0 ? void 0 : getRequestAccessCountState.value;
    useEffect(function() {
        _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getRequestAccessCount()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        getRequestAccessCount
    ]);
    return /*#__PURE__*/ React.createElement("button", _object_spread({
        type: "button",
        ref: ref,
        className: classNames('share-link', small && 'small')
    }, getReferenceProps()), /*#__PURE__*/ React.createElement("img", {
        src: "/public/img/".concat(small ? 'share-link-small' : 'share-link', ".svg"),
        alt: "share-link"
    }), small ? /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, text('share')) : null, count && count > 0 ? /*#__PURE__*/ React.createElement(Badge, {
        pill: true,
        variant: "danger",
        className: "share-link__badge-count"
    }, count) : null);
});
ShareLinkButton.displayName = 'ShareLinkButton';
ShareLinkButton.propTypes = {
    small: T.bool
};
var ShareLinkConsumer = function() {
    var _useContext = useContext(ShareLinkContext), isOpen = _useContext.isOpen, refs = _useContext.refs, context = _useContext.context;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ShareLinkButton, {
        ref: refs.setReference
    }), isOpen ? /*#__PURE__*/ React.createElement(FloatingFocusManager, {
        context: context,
        modal: false
    }, /*#__PURE__*/ React.createElement(ShareLinkContent, {
        ref: refs.setFloating
    })) : null);
};
var ShareLink = function(param) {
    var projectId = param.projectId, redirectUrl = param.redirectUrl, _param_showHomeIcon = param.showHomeIcon, showHomeIcon = _param_showHomeIcon === void 0 ? false : _param_showHomeIcon, metadata = param.metadata, new3dBookmark = param.new3dBookmark, small = param.small;
    var dispatch = useDispatch();
    var _useCopyToClipboard = _sliced_to_array(useCopyToClipboard(), 2), copyToClipboard = _useCopyToClipboard[1];
    var _useAsyncFn = _sliced_to_array(useAsyncFn(/*#__PURE__*/ _async_to_generator(function() {
        var resp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.createBookmark(projectId, redirectUrl, metadata)
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        2,
                        resp.data
                    ];
            }
        });
    }), [
        projectId,
        redirectUrl,
        metadata
    ]), 2), createBookmarkState = _useAsyncFn[0], createBookmark = _useAsyncFn[1];
    var _useAsyncFn1 = _sliced_to_array(useAsyncFn(/*#__PURE__*/ _async_to_generator(function() {
        var resp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.listRequestAccess(projectId)
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        2,
                        resp.data
                    ];
            }
        });
    }), [
        projectId
    ]), 2), listRequestsState = _useAsyncFn1[0], listRequests = _useAsyncFn1[1];
    var _useAsyncFn2 = _sliced_to_array(useAsyncFn(/*#__PURE__*/ _async_to_generator(function() {
        var resp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.getRequestAccessCount(projectId)
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        2,
                        resp.data
                    ];
            }
        });
    }), [
        projectId
    ]), 2), getRequestAccessCountState = _useAsyncFn2[0], getRequestAccessCount = _useAsyncFn2[1];
    var handleShareLinkOpen = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Promise.all so these can happen concurrently
                        return [
                            4,
                            Promise.all([
                                new Promise(function(ok, rej) {
                                    return createBookmark().then(function(param) {
                                        var url = param.url;
                                        copyToClipboard(url);
                                        ok();
                                    }).catch(rej);
                                }),
                                listRequests(),
                                getRequestAccessCount()
                            ])
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleShareLinkOpen() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        if (createBookmarkState.error) {
            captureError(createBookmarkState.error);
            dispatch(alertError(createBookmarkState.error.message));
        }
    }, [
        createBookmarkState,
        dispatch
    ]);
    useEffect(function() {
        if (listRequestsState.error) {
            captureError(listRequestsState.error);
            dispatch(alertError(listRequestsState.error.message));
        }
    }, [
        listRequestsState,
        dispatch
    ]);
    useEffect(function() {
        if (getRequestAccessCountState.error) {
            captureError(getRequestAccessCountState.error);
            dispatch(alertError(getRequestAccessCountState.error.message));
        }
    }, [
        getRequestAccessCountState,
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(ShareLinkProvider, {
        createBookmarkState: createBookmarkState,
        listRequests: listRequests,
        listRequestsState: listRequestsState,
        getRequestAccessCount: getRequestAccessCount,
        getRequestAccessCountState: getRequestAccessCountState,
        onOpen: handleShareLinkOpen,
        showHomeIcon: showHomeIcon,
        new3dBookmark: new3dBookmark,
        small: small
    }, /*#__PURE__*/ React.createElement(ShareLinkConsumer, null));
};
ShareLink.propTypes = {
    projectId: T.number.isRequired,
    redirectUrl: T.string.isRequired,
    showHomeIcon: T.bool,
    metadata: T.object,
    new3dBookmark: T.func,
    small: T.bool
};
export default ShareLink;
